module.exports = __webpack_public_path__ + "static/media/fusion-ginssen-icon-04.30a3062c.png";